import { makeStyles } from '@material-ui/core/styles';
import getCommonStyles from './_common';

const useAboutUsStyles = makeStyles((theme) => ({
  ...getCommonStyles(theme),
  root: {
    ...getCommonStyles(theme).sectionContainer,
    position: 'relative',
    background: 'transparent',
    padding: theme.spacing(12, 0, 12),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 0, 8),
    },
  },
  sectionTitle: {
    ...getCommonStyles(theme).sectionTitle,
    fontFamily: '"vester-medium", "Montserrat", "Inter", sans-serif',
    fontWeight: 800,
    letterSpacing: '-0.02em',
    lineHeight: 1.08,
    background: 'linear-gradient(135deg, #ffffff 0%, #cdfaf1 45%, #6fe9d6 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: theme.spacing(3.5),
    fontSize: '3rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  sectionDescription: {
    ...getCommonStyles(theme).sectionDescription,
    fontFamily: '"Montserrat", "Inter", "Segoe UI", sans-serif',
    fontSize: '1.15rem',
    lineHeight: 1.95,
    color: '#b5c3d3',
    maxWidth: '900px',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
}));
export default useAboutUsStyles;
